// extracted by mini-css-extract-plugin
module.exports = {"tickets":"_8a1859a","innerSlider":"_6593ecd","cardContainer":"_8114690"};